import { describe, expect, it } from "vitest";

import { planData } from "./data";

const PAID_SIGNUP_URL = "/sign-up?next=package";

describe("paid plan CTAs", () => {
  const paidCtaUrls = planData
    .filter((plan) => plan.cta?.text === "Get started")
    .map((plan) => plan.cta?.url);

  it("sends the paid plans to signup rather than the retired payment form", () => {
    expect(paidCtaUrls).toEqual([PAID_SIGNUP_URL, PAID_SIGNUP_URL]);
  });

  it("leaves no route to the retired signup-and-payment form", () => {
    const allUrls = planData.map((plan) => plan.cta?.url);
    expect(allUrls.filter((url) => url?.includes("paid_sign_up"))).toEqual([]);
  });
});
